// MUI font styles overrides

export function remToPx(value) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }) {
  return {
    "@media (min-width:600px)": {
      fontSize: pxToRem(sm),
    },
    "@media (min-width:900px)": {
      fontSize: pxToRem(md),
    },
    "@media (min-width:1200px)": {
      fontSize: pxToRem(lg),
    },
  };
}

const primaryFont = `Inter, serif`;

export const typography = (mode) => ({
  fontFamily: primaryFont,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 800,
    lineHeight: 80 / 64,
    fontSize: "var(--h1)",
  },
  h2: {
    fontWeight: 800,
    lineHeight: 64 / 48,
    fontSize: "var(--h2)",
  },
  h3: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: "var(--h3)",
  },
  h4: {
    fontWeight: 600,
    lineHeight: 1,
    fontSize: "var(--h4)",
  },
  h5: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
    ...responsiveFontSizes({ sm: 15, md: 17, lg: 19 }),
  },
  h6: {
    fontWeight: 600,
    fontSize: pxToRem(11),
    ...responsiveFontSizes({ sm: 12, md: 13, lg: 14 }),
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
  },
  norace: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(17),
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 15 / 14,
    fontSize: pxToRem(13),
  },
  teamnamebb: {
    fontWeight: 400,
    lineHeight: 15 / 14,
    fontSize: pxToRem(13),
  },
  leaguenamepp: {
    fontWeight: 400,
    lineHeight: 15 / 14,
    fontSize: pxToRem(13),
  },
  body1: {
    lineHeight: 1.5,
    fontSize: pxToRem(15),
  },
  body2: {
    lineHeight: 22 / 14,
    fontSize: pxToRem(13),
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(10),
  },
  slipinfo: {
    lineHeight: 1.5,
    fontSize: pxToRem(13),
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: "uppercase",
  },
  string: {
    fontWeight: 300,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  button: {
    fontWeight: 700,
    lineHeight: 24 / 14,
    fontSize: "var(--content)",
    textTransform: "unset",
  },
});
